import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { FOOTER } from "@/content/landing";

export default function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className="landing-footer-top">
        <div className="landing-footer-brand"><Logo /><p>{FOOTER.tagline}</p></div>
        {FOOTER.columns.map(col => (
          <div key={col.title} className="landing-footer-col">
            <h4>{col.title}</h4>
            {col.links.map(l => <Link key={l.label} to={l.to}>{l.label}</Link>)}
          </div>
        ))}
      </div>
      <div className="landing-footer-bottom"><span>Perform © {new Date().getFullYear()}</span><span>Fait en France.</span></div>
    </footer>
  );
}
